import { motion } from "framer-motion";
import { Utensils, ShoppingBag, Truck, Globe, Users, ArrowUpRight } from "lucide-react";
import { SectionHead, EASE } from "./Reveal";
import { useLang } from "../../lib/lang";
import { INFO } from "../../lib/content";

const ICONS = { dine: Utensils, take: ShoppingBag, deliver: Truck, online: Globe, group: Users };

export const Services = () => {
  const { t } = useLang();
  return (
    <section id="services" data-testid="services-section" className="relative bg-transparent py-24 lg:py-36">
      <div className="mx-auto grid max-w-[1400px] grid-cols-12 gap-y-14 px-5 lg:gap-x-16 lg:px-10">
        <div className="col-span-12 lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <SectionHead eyebrow={t.services.eyebrow} title={t.services.title} titleEm={t.services.titleEm} />
            <div className="arch mt-10 hidden aspect-[3/4] w-full max-w-[320px] overflow-hidden lg:block">
              <img src="/food/wrap.webp" alt="Shawarma rulle" className="h-full w-full object-cover" />
            </div>
          </div>
        </div>
        <ul className="col-span-12 lg:col-span-8">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[s.k];
            return (
              <motion.li
                key={s.k}
                data-testid={`service-item-${s.k}`}
                initial={{ y: 30 }}
                whileInView={{ y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.8, ease: EASE, delay: i * 0.06 }}
                className="group relative border-t border-[#721121]/15 last:border-b"
              >
                <a href={INFO.phoneHref} className="relative z-10 grid grid-cols-12 items-center gap-4 py-8 sm:py-10">
                  <span className="col-span-2 font-mono text-xs text-[#721121] sm:col-span-1">0{i + 1}</span>
                  <span className="col-span-10 sm:col-span-5">
                    <span className="flex items-center gap-4">
                      <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-[#721121]/25 text-[#721121] transition-colors duration-500 group-hover:bg-white group-hover:border-white"><Icon size={18} /></span>
                      <span className="font-display text-3xl tracking-tight text-[#1C1917] transition-colors duration-500 group-hover:text-white sm:text-4xl">{s.title}</span>
                    </span>
                  </span>
                  <span className="col-span-10 col-start-3 text-[15px] leading-relaxed text-[#57534E] transition-colors duration-500 group-hover:text-white/85 sm:col-span-5 sm:col-start-auto">{s.desc}</span>
                  <ArrowUpRight className="col-span-1 hidden justify-self-end text-[#721121] transition-[transform,color] duration-500 group-hover:rotate-45 group-hover:text-white sm:block" />
                </a>
                <span className="absolute inset-0 origin-bottom scale-y-0 bg-[#721121] transition-transform duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-y-100" />
              </motion.li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
